import React, { useState, Fragment } from 'react';
import ImgCrop from 'antd-img-crop';
import { Upload, Button, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 14, color: '#fff' }} spin />;

function ImageCropper(props) {
  const { setUploadedFile, uploadNow, spinLoader } = props;
  const [fileList, setFileList] = useState([]);

  const onChange = ({ fileList: newFileList }) => {
    console.log(newFileList);
    setFileList(newFileList);
    if (newFileList.length > 0) {
      setUploadedFile(newFileList[0].originFileObj);
    }
  };

  const onPreview = async (file) => {
    let src = file.url;
    console.log('src', src);
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);

    if (imgWindow) {
      imgWindow.document.write(image.outerHTML);
    } else {
      window.location.href = src;
    }
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <ImgCrop grid>
        <Upload action='https://www.mocky.io/v2/5cc8019d300000980a055e76' listType='picture-card' fileList={fileList} onChange={onChange} onPreview={onPreview}>
          {fileList.length >= 1 ? '' : '+ Upload'}
        </Upload>
      </ImgCrop>
      <Button disabled={fileList.length === 0} onClick={uploadNow} type='primary' size='small' style={{ marginLeft: -8 }}>
        {spinLoader ? (
          <Fragment>
            Uploading <Spin indicator={antIcon} />
          </Fragment>
        ) : (
          'Upload now'
        )}
      </Button>
    </div>
  );
}

export default ImageCropper;
